// extracted by mini-css-extract-plugin
export default {"access":"nFmsjamXAPEzKjHt6yXr","bg":"GhqU_XWrT8Owrlq5OPEY","icon":"CkNdroDKYPWjExwQYm42","btn":"ax6iEHKyWR7p3LuYQiH3","counter":"bz02HEApuWb3h9B027rM"};